import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UsStates } from 'src/app/_data/us-states';
import { BaseService } from 'src/app/_services/base.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ReportsService } from 'src/app/_services/reports.service';
import { ConfirmationService } from 'primeng/api';
import { ConnMessageService } from 'src/app/_services/conn-message.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Router } from '@angular/router';
interface Status {
  id: number,
  value: string
}
@Component({
  selector: 'app-sales-invoice-detail',
  templateUrl: './sales-invoice-detail.component.html',
  styleUrls: ['./sales-invoice-detail.component.scss']
})
export class SalesInvoiceDetailComponent implements OnInit {
  invoiceNumber: any = ''
  usaStates = UsStates
  billingAddres: any = null
  shippingAddress: any = null

  _globals = GlobalService
  isApiLoading: boolean = false;
  showPrintPreview = false
  showDocumentsCard = false

  constructor(
    private _confirmationService: ConfirmationService,
    private _bs: BaseService,
    private _connMessageService: ConnMessageService,
    public _reportService: ReportsService,
    private _spinner: NgxSpinnerService,
    private _abd: AppBaseDataService,
    private _router: Router
  ) { }

  ngOnInit(): void {
    try {
      this.invoiceNumber = this._reportService.selectedInvoiceRow?.invoiceNumber
      if (!this.invoiceNumber || !String(this.invoiceNumber).trim()) {
        this._connMessageService.showToastMessage('Please select an order from Sales Orders first.', 'error');
        this._router.navigate(['app/sales-orders']);
        return;
      }
      this.loadInvoiceDetails()

    }
    catch (e) {
      this._abd.hideSpinner();
      this._connMessageService.showToastMessage(e, 'error');
    }
  }
  private loadInvoiceDetails(): void {
    if (!this.invoiceNumber) return
    this._abd.showSpinner()
    this.billingAddres = null;
    this.isApiLoading = true;
    this._reportService.searchInvoiceByID(this.invoiceNumber).subscribe(res => {
      this._abd.hideSpinner()
      if (!res?.success) {
        this._connMessageService.showToastMessage('Failed to fetch invoice details', 'error');
        return
      }
      this.applyInvoiceDetails(res.data)
    }, error => {
      this.isApiLoading = false;
      this._abd.hideSpinner();
      this._connMessageService.showToastMessage('Failed to fetch invoice details', 'error');
    }, () => { this.isApiLoading = false; });
  }

  private applyInvoiceDetails(data: any): void {
    console.log("API response", { data })
    this._reportService.selectedInvoiceDetails = data
    this.billingAddres = this._reportService.selectedInvoiceDetails.invoiceBilling[0]

    const invoiceNote = this.resolveNoteValue(data?.InvoiceNote, data?.invoiceNote)
    const customerNote = this.resolveNoteValue(data?.CustomerNote, data?.customerNote)
    this._reportService.selectedInvoiceDetails.InvoiceNote = invoiceNote
    this._reportService.selectedInvoiceDetails.invoiceNote = invoiceNote
    this._reportService.selectedInvoiceDetails.CustomerNote = customerNote
    this._reportService.selectedInvoiceDetails.customerNote = customerNote

    const detail = [
      { label: 'Transaction Type', value: data.invoiceTypeString },
      { label: 'Dated', value: formatDate(new Date(data.dated), 'MM/dd/yy hh:mm a', 'en-US') },
    ]

    if (data.isOnlineOrder) {
      detail.push({ label: 'Shipping Status', value: data.shippingStatusString })
      detail.push({ label: 'Placement', value: 'Online' })
      detail.push({ label: 'Shipping Location', value: data.locationName })
    }
    else {
      detail.push({ label: 'Placement', value: 'In-Store' }),
        { label: 'Location', value: data.locationName },
        detail.push({ label: 'Register', value: data.registerName },
          { label: 'Cashier', value: data.userName },
        )
    }
    if (data.refInvoiceNumber != null && data.refInvoiceNumber != undefined) {
      detail.push({ label: 'Refunded Against', value: data.refInvoiceNumber })
    }
    if (data.returnedInvoices) {
      let returnInvoiceNumbers = ''
      data.returnedInvoices?.forEach(element => {
        returnInvoiceNumbers = returnInvoiceNumbers + ' ' + element
      });
    }
    if (data.refInvoiceNumber != null && data.refInvoiceNumber != undefined) {
      detail.push({ label: 'Refunded Against', value: data.refInvoiceNumber })
    }
    if (data.returnedInvoices) {
      let returnInvoiceNumbers = ''
      data.returnedInvoices?.forEach(element => {
        returnInvoiceNumbers = returnInvoiceNumbers + ' ' + element
      });

      detail.push({ label: 'Refunded Via', value: returnInvoiceNumbers })
    }
    const customerDetails = [
      { label: 'Customer Name', value: data.customerName },
      { label: 'Phone', value: this._globals.generatePhoneFormatUS(data.customerPhone) },
      { label: 'Awarded Points', value: data.pointsAwarded },
      { label: 'Reward Discount ($)', value: data.rewardDiscount },
      { label: 'Points Redeemed', value: data.redeemedPoints },
    ]

    const documents = [
      { label: 'Receipt', value: data.invoiceNumber },
    ]

    let paymentAddress: any = null
    if (data.invoiceShipping.length) {
      const obj = {
        address1: data.invoiceShipping[0].address1,
        address2: data.invoiceShipping[0].address2,
        city: data.invoiceShipping[0].city,
        state: data.invoiceShipping[0].state + ' ' + data.invoiceShipping[0].zipCode
      }
      paymentAddress = obj
    }

    let billingAddress: any = null
    if (data.invoiceBilling.length) {
      const obj = {
        address1: data.invoiceBilling[0].address1,
        address2: data.invoiceBilling[0].address2,
        city: data.invoiceBilling[0].city,
        state: data.invoiceBilling[0].state + ' ,' + data.invoiceBilling[0].zipCode
      }
      billingAddress = obj
    }

    this._reportService.selectedInvoiceDetails.invoiceOrderDetail = detail
    this._reportService.selectedInvoiceDetails.invoiceCustomerDetails = customerDetails
    this._reportService.selectedInvoiceDetails.invoiceDocuments = documents
    this._reportService.selectedInvoiceDetails.paymentAddress = paymentAddress
    this._reportService.selectedInvoiceDetails.billingAddress = billingAddress

    this.SelectedStatus = this.OrderStatus.filter(u => u.value == this._reportService.selectedInvoiceDetails.postedStatusString)[0]
  }

  private resolveNoteValue(primary: any, secondary: any): string {
    const first = String(primary ?? '')
    const second = String(secondary ?? '')
    if (first.trim().length) return first
    if (second.trim().length) return second
    return first || second || ''
  }

  onInvoiceNoteChange(value: any): void {
    const note = String(value ?? '')
    if (!this._reportService?.selectedInvoiceDetails) return
    this._reportService.selectedInvoiceDetails.invoiceNote = note
    this._reportService.selectedInvoiceDetails.InvoiceNote = note
  }

  onCustomerNoteChange(value: any): void {
    const note = String(value ?? '')
    if (!this._reportService?.selectedInvoiceDetails) return
    this._reportService.selectedInvoiceDetails.customerNote = note
    this._reportService.selectedInvoiceDetails.CustomerNote = note
  }
  OrderStatus = [
    { id: 1, value: "Completed" },
    { id: 2, value: "Pending Payment" },
    { id: 3, value: "Processing" },
    { id: 4, value: "Hold" },
    { id: 5, value: "Cancelled" },
    { id: 6, value: "Refunded" },
    { id: 7, value: "Failed" },
    { id: 8, value: "Draft" },
  ]

  SelectedStatus: Status;

  showEditDropDown() {

    if (
      this._reportService.selectedInvoiceDetails.isOnlineOrder
      && (
        this._reportService.selectedInvoiceDetails.postedStatusString == 'Processing' ||
        this._reportService.selectedInvoiceDetails.postedStatusString == 'Pending Payment'
        || this._reportService.selectedInvoiceDetails.postedStatusString == 'Hold'
        || this._reportService.selectedInvoiceDetails.postedStatusString == 'Cancelled'
        || this._reportService.selectedInvoiceDetails.postedStatusString == 'Completed'
      )
    )
      return true;
    return false;


  }
  backButtonClicked() {
    window.history.back()
  }
  StatusChanged(status) {
    this.AllowUpdate = false;

  }
  AllowUpdate: boolean = true;
  ChangeOrderStatus() {
    // console.log(this.SelectedStatus)
    this._confirmationService.confirm({
      message: 'Are you sure that you want to change order status?',
      header: 'Update Order Status',
      icon: 'pi pi-info-circle',
      accept: () => {

        this._spinner.show()
        try {
          let PostedStatus = this.SelectedStatus.value.replace(/\s/g, "");
          let ShippingStatus = PostedStatus == "Completed" ? "Dispatched" : "Pending Delivery"
          ShippingStatus = ShippingStatus.replace(/\s/g, "");
          const invoiceNote = this.resolveNoteValue(
            this._reportService.selectedInvoiceDetails?.invoiceNote,
            this._reportService.selectedInvoiceDetails?.InvoiceNote
          )
          const customerNote = this.resolveNoteValue(
            this._reportService.selectedInvoiceDetails?.CustomerNote,
            this._reportService.selectedInvoiceDetails?.customerNote
          )
          this._reportService.selectedInvoiceDetails.InvoiceNote = invoiceNote
          this._reportService.selectedInvoiceDetails.invoiceNote = invoiceNote
          this._reportService.selectedInvoiceDetails.CustomerNote = customerNote
          this._reportService.selectedInvoiceDetails.customerNote = customerNote

          const data = {
            InvoiceNumber: this._reportService.selectedInvoiceDetails.invoiceNumber,
            PostedStatus: PostedStatus,
            ShippingStatus: ShippingStatus,
            InvoiceNote: invoiceNote,
            CustomerNote: customerNote,

          }
          this._reportService.UpdateInvoiceStatus(data).subscribe(res => {
            if (res.success && res.data === true) {
              this._reportService.selectedInvoiceDetails.postedStatusString = this.SelectedStatus.value
              this._reportService.selectedInvoiceDetails.shippingStatusString = ShippingStatus
              this._connMessageService.showToastMessage("Order Updated Sucessfully", 'info');
              this.loadInvoiceDetails()

            }
            else {
              this._connMessageService.showToastMessage("Order failed to updated", 'error');
            }
            this._spinner.hide()
          }, () => {
            this._connMessageService.showToastMessage("Order failed to updated", 'error');
            this._spinner.hide()
          });


        }
        catch {
          this._spinner.hide()
        }
      },
      reject: () => { }
    })
  }


}
